import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_MONITORS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch monitoring data.'),
      403: i18n.t('You are not allowed to fetch monitoring data.'),
      404: i18n.t('The monitoring data you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching monitoring data.'),
      default: i18n.t('An error occurred fetching monitoring data.')
    },
    SUCCESS: {
      200: i18n.t('Monitors fetched successfully.')
    }
  },
  FETCH_MONITORING: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the agent monitoring data.'),
      403: i18n.t('You are not allowed to fetch the agent monitoring data.'),
      404: i18n.t('The agent monitoring data you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the agent monitoring data.'),
      default: i18n.t('An error occurred fetching the agent monitoring data.')
    },
    SUCCESS: {
      200: i18n.t('Monitoring fetched successfully.')
    }
  },
  DELETE_MONITORING: {
    ERROR: {
      401: i18n.t('You are not authorized to disable agent monitoring.'),
      403: i18n.t('You are not allowed to disable agent monitoring.'),
      404: i18n.t('The monitoring you are trying to disable does not exist.'),
      500: i18n.t('There was an error disabling agent monitoring.'),
      default: i18n.t('An error occurred disabling agent monitoring.')
    },
    SUCCESS: {
      200: i18n.t('Agent monitoring disabled.')
    }
  },
  CREATE_MONITORING: {
    ERROR: {
      401: i18n.t('You are not authorized to enable agent monitoring.'),
      403: i18n.t('You are not allowed to enable agent monitoring.'),
      404: i18n.t('The agent monitoring you are trying to enable does not exist.'),
      500: i18n.t('There was an error enabling agent monitoring.'),
      default: i18n.t('An error occurred creating agent monitoring.')
    },
    SUCCESS: {
      200: i18n.t('Agent monitoring enabled.')
    }
  }
};
